import { applyFilters, getFiltersData, getFiltersValues } from '@/components/uiKit/FiltersGroup/utils';
import { notificationPreferencesFilterConfig } from '@/store/slices/notificationPreferencesSlice/filter-config';
import { FiltersValues } from '@/components/uiKit/FiltersGroup/types';

export const getNotificationPreferencesFiltersValues = (notificationPreferencesAssets: any[]) => {
  const { allFiltersValues, initialFiltersValues, currentFiltersValues } = getFiltersValues(
    notificationPreferencesAssets,
    notificationPreferencesFilterConfig
  );

  return {
    allFiltersValues,
    initialFiltersValues,
    currentFiltersValues,
  };
};

export const getNotificationPreferencesFilteredAssets = (
  notificationPreferencesAssets: any[],
  currentFiltersValues: any
) => {
  const filteredNotificationPreferencesAssets = applyFilters(
    notificationPreferencesAssets,
    notificationPreferencesFilterConfig,
    currentFiltersValues
  );

  return filteredNotificationPreferencesAssets;
};

export const getNotificationPreferencesFiltersData = (
  notificationPreferencesAssets: any[],
  currentFiltersValues: FiltersValues,
  allFiltersValues: FiltersValues
) => {
  const filteredNotificationPreferencesAssets = getNotificationPreferencesFilteredAssets(
    notificationPreferencesAssets,
    currentFiltersValues
  );

  const notificationPreferencesFiltersData = getFiltersData(
    notificationPreferencesAssets,
    filteredNotificationPreferencesAssets,
    notificationPreferencesFilterConfig,
    currentFiltersValues,
    allFiltersValues
  );

  return notificationPreferencesFiltersData;
};
